import React from "react";

interface ToastProps {
	type: string;
	role: string;
	title: string;
	content: string;
	onClose: React.MouseEventHandler<HTMLButtonElement>;
}

export function Toast({ type, role, title, content, onClose }: ToastProps) {
	return (
		<div className={`toast toast--${type}`} role={role}>
			<span className="toast__icon"></span>
			<h6 className="toast__title">{title}</h6>
			<p>{content}</p>
			<button
				type="button"
				className="toast__close-btn"
				onClick={onClose}
			></button>
		</div>
	);
}
